import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../auth/AuthProvider';
import { updateProfile } from '../../controllers/user';

const PerfilMatrimonioForm = forwardRef((props, ref) => {
  const [nombreEsposo, setNombreEsposo] = useState(props.perfil?.nombre1 || '');
  const [nombreEsposa, setNombreEsposa] = useState(props.perfil?.nombre2 ||'');
  const [apellido, setApellido] = useState(props.perfil?.apellido || '');
  const [telefono1, setTelefono1] = useState(props.perfil?.telefono1 || '');
  const [telefono2, setTelefono2] = useState(props.perfil?.telefono2 || '');
  const [alert, setAlert] = useState();
  const { token } = useAuth();

  useImperativeHandle(ref, () => ({
    getPerfil() {
      return generatePerfil();
    }
  }));

  function handleChange(e) {
    const value = e.target.value;
    switch (e.target.name) {
      case 'nombreEsposo': setNombreEsposo(value); break;
      case 'nombreEsposa': setNombreEsposa(value); break;
      case 'apellido': setApellido(value); break;
      case 'telefono1': setTelefono1(value); break;
      case 'telefono2': setTelefono2(value); break;
    }
  }

  function generatePerfil() {
    return {
      tipo: 'matrimonio',
      nombre1: nombreEsposo,
      nombre2: nombreEsposa,
      apellido,
      telefono1,
      telefono2
    };
  }

  async function submitUpdate() {
    let p = generatePerfil();
    console.log(p);

    try {
      let r = await updateProfile(token, props.userId, p);
      setAlert(<Alert variant='success' onClose={() => setAlert()} dismissible>La información se actualizó con éxito.</Alert>);
    }
    catch (e) {
      console.log(e);
      setAlert(<Alert variant='danger' onClose={() => setAlert()} dismissible>Ocurrió un error. Por favor intenta de nuevo más tarde.</Alert>);
    }
  }

  function renderSaveButton() {
    if (props.updateProfile) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-perfil' type='submit' variant='primary' onClick={submitUpdate}>Actualizar perfil</Button>
      </Form.Group>;
    }
  }

  return <Row>
    <Col>
      {alert}
      <Form.Group className="mb-3">
        <Form.Label>Nombre del esposo</Form.Label>
        <Form.Control type="text" placeholder="Nombre del esposo" name='nombreEsposo' value={nombreEsposo} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Nombre de la esposa</Form.Label>
        <Form.Control type="text" placeholder="Nombre de la esposa" name='nombreEsposa' value={nombreEsposa} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Apellido</Form.Label>
        <Form.Control type="text" placeholder="Apellido" name='apellido' value={apellido} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Teléfono Esposo</Form.Label>
        <Form.Control type="tel" placeholder='Teléfono Esposo' name='telefono1' value={telefono1} onChange={handleChange} pattern='\d{10}' title='Formato 1234567890' required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Teléfono Esposa</Form.Label>
        <Form.Control type="tel" placeholder="Teléfono Esposa" name='telefono2' value={telefono2} onChange={handleChange} pattern='\d{10}' title='Formato 1234567890' required />
      </Form.Group>

      {renderSaveButton()}
    </Col>
  </Row>;
});

export default PerfilMatrimonioForm;